// extracted by mini-css-extract-plugin
export default {"rippleButton":"rippleButton_rippleButton__1Ii8L","ripple":"rippleButton_ripple__wfNNw","ripple-effect":"rippleButton_ripple-effect__JVlH6","content":"rippleButton_content__H5CYc"};